import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

class CustomError extends Error {
    constructor(title, message, severity) {
        super(message);
        this.title = title;
        this.severity = severity;
    }
}

export const getWebContentSurveyLink = async (agentEmail) => {
    try {
        const response = await axios.get(`${baseURL}/api/survey-monkey/wc-survey-link`, {
            params: { email: agentEmail },
            headers: {
                'api-key': apiKey
            }
        });
        return response.data.surveyLink;
    } catch (error) {
        if (error.response) {
            if (error.response.status === 400) {
                throw new CustomError(
                    "It looks like the email you submitted is either incorrect or you are not currently opted into DAC's SEO Website Content.",
                    "Please verify that you have entered the correct State Farm Alias email. If you continue to receive this error message and need assistance, please contact our team at 866-473-9747 or StateFarmHelp@dacgroup.com",
                    "warning"
                );
            } else if (error.response.status === 500) {
                throw new CustomError(
                    "An internal server error occurred.",
                    "Please try again later.",
                    "error"
                );
            }
        }
        throw new CustomError(
            "Failed to fetch the survey.",
            "Please try again.",
            "error"
        );
    }
};